import { useSelector } from 'react-redux';

import {
  getKnmIsCommonWatchOnly,
  getKnmIsErknmStatusCommentsExist,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { getIsPlanErknmStatusConsidered } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';

export const useIsKindKnmEnabled = () => {
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const isKnmPlanStatusConsidered = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.KIND_KNM);

  return !isCommonWatchOnly && isSupervisor && isKnmStatusCommentsExist && isKnmPlanStatusConsidered && isRemarksExists;
};
